import React, { isValidElement, useEffect, useId, useState } from 'react';
import { OverlayTrigger, Tooltip, TooltipProps } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/types';
import 'src/components/common/vx/css/TooltipPopover.css';

type ElementWithTooltipProps = {
  element: React.JSX.Element;
  tooltip: React.JSX.Element;
  placement?: Placement;
};

let closeActiveTooltip: (() => void) | null = null;

export function ElementWithTooltipOrig({ element, tooltip, placement }: ElementWithTooltipProps) {
  const tooltipId = useId();
  const [show, setShow] = useState(false);

  const closeSelf = () => {
    setShow(false);
    if (closeActiveTooltip === closeSelf) {
      closeActiveTooltip = null;
    }
  };

  const openSelf = () => {
    if (closeActiveTooltip && closeActiveTooltip !== closeSelf) {
      closeActiveTooltip();
    }
    closeActiveTooltip = closeSelf;
    setShow(true);
  };

  useEffect(() => {
    return () => {
      if (closeActiveTooltip === closeSelf) {
        closeActiveTooltip = null;
      }
    };
  }, []);

  const safeElement =
    isValidElement(element) && typeof element.type === 'string' ? element : <span>{element}</span>;

  const renderTooltip = (
    props: React.JSX.IntrinsicAttributes & TooltipProps & React.RefAttributes<HTMLDivElement>,
  ) => (
    <Tooltip
      id={tooltipId}
      {...props}
    >
      {tooltip}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      show={show}
      placement={placement ?? 'top'}
      overlay={renderTooltip}
      delay={{ show: 100, hide: 100 }}
      onToggle={(nextShow) => {
        if (nextShow) {
          openSelf();
        } else {
          closeSelf();
        }
      }}
    >
      {safeElement}
    </OverlayTrigger>
  );
}
